module.exports = __webpack_public_path__ + "img/shoerackA19.b66ce16f.jpg";